import React from "react";
import Weather from "./Weather.js"
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="app-wrapper">
          <div className="app">
            <h1>Weather Forecast</h1>
            <Weather
              currentCity= "London"
            />
          </div>
          <footer>
            This <a href="https://github.com/cvg221/weather-forecast-app-react" target="_blank" rel="noreferrer">open-source project </a>
            was created by Carolina Villanueva 👩‍💻
          </footer>
        </div>
      </div>
    </div>
  );
}
